
import { SectionWithUserCardProps } from './query';
import Button_v2 from '@/components/molecules/Button/index';
import Text from '@/components/molecules/Text';
import Title_v2 from '@/components/molecules/Title/index';
import UserCard from '@/components/molecules/UserCard';
import { renderUnderline } from '@/utilities/functions';

const SectionWithCtaCard = ({ sectionWithUserCardData }: { sectionWithUserCardData: SectionWithUserCardProps }) => {
	return (
		<>
			<Title_v2
				align={sectionWithUserCardData.title.alignedAt}
				underlineColor={sectionWithUserCardData.title.underlineColor}
			>
				{renderUnderline(sectionWithUserCardData.title.titlePieces)}
			</Title_v2>
			{sectionWithUserCardData.description && (
				<Text textAlign='center'>
					{sectionWithUserCardData.description}
				</Text>
			)}
			{sectionWithUserCardData.cards.map(
				(card, index) => (
					<UserCard key={index}
						userDescription={card.userDescription}
						userName={card.userName}
						userPosition={card.userPosition}
						userImage={card.userPicture.data.attributes.url}
						funFact={card.funFact}
						favoriteMusic={card.favoriteMusic}
					/>
				),
			)}
			{sectionWithUserCardData.buttons && (
				sectionWithUserCardData.buttons.map(
					(button, index) => (
						<Button_v2
							gtm_id={button.trackerId}
							href={button.url}
							key={index}
							openOnNewTab={button.newTab}
							text={button.text}
							version={button.variant}
						/>
					),
				)
			)}
		</>
	);
};

export default SectionWithCtaCard;
